import {createContext} from 'react';

import noop from '@tinkoff/utils/function/noop';

import {type InviteMembersState} from './use_invite_members_state';

const defaultState: InviteMembersState = {
    channelError: null,
    failedToSendInvites: false,
    profilesByEmail: {},
    rateLimitIssues: [],
    rateLimitTimeoutMinutes: 0,
    sendingIssues: [],
    sendInvites: () => Promise.resolve(),
    reset: noop,
    result: [],
    profiles: [],
    generalError: null,
    success: false,
    errors: [],
    criticalErrors: [],
    warnings: [],
};

export const inviteMembersContext = createContext<InviteMembersState>(defaultState);

export const InviteMembersStateProvider = inviteMembersContext.Provider;
